import { apiClient } from '@/config/api';
import { ApiResponse } from '@/types/status';

export interface Series {
    _id: string;
    key: string;
    name: string;
    description?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface CreateSeriesDto {
    key: string;
    name: string;
    description?: string;
}

export interface UpdateSeriesDto extends Partial<CreateSeriesDto> {}

export interface GetPaginationSeriesDto {
    page?: number;
    limit?: number;
    search?: string;
}

const SERIES_ENDPOINTS = {
    SERIES: '/series',
    BY_ID: (id: string) => `/series/${id}`,
};

export const seriesService = {
    create(data: CreateSeriesDto): Promise<ApiResponse<any>> {
        return apiClient.post(SERIES_ENDPOINTS.SERIES, data);
    },
    findAll(query: GetPaginationSeriesDto): Promise<ApiResponse<any>> {
        return apiClient.get(SERIES_ENDPOINTS.SERIES, query);
    },
    findOne(id: string): Promise<ApiResponse<any>> {
        return apiClient.get(SERIES_ENDPOINTS.BY_ID(id));
    },
    update(id: string, data: UpdateSeriesDto): Promise<ApiResponse<any>> {
        return apiClient.put(SERIES_ENDPOINTS.BY_ID(id), data);
    },
    remove(id: string): Promise<ApiResponse<any>> {
        return apiClient.delete(SERIES_ENDPOINTS.BY_ID(id));
    },
};


